module.exports = __webpack_public_path__ + "img/face_auth_advantage_1.b2779f95.png";